import { ColumnBuilder } from '../../../../bidding/common/table/columns/column-builder/ColumnBuilder';
import { collapseStickRightColumn } from '../../../../bidding/common/table/CollapseStickRightColumn';
import {
    isNewColumn,
    createLastUpdatedColumn,
    dealNameColumn,
    dealTickerColumn,
    transactionStatusColumn,
    transactionTypeColumn,
    transactionCollateralTypeColumn,
    transactionCurrencyColumn,
    transactionSizeColumn,
    pricingDateColumn,
    closingDateColumn,
    nonCallPeriodEndColumn,
    reinvestmentPeriodEndColumn,
    dealOptionsColumn,
    dealIntexColumn,
    createGoToColumn,
    createRelatedTransactionsColumn,
    nonCallPeriodEndYrsColumn,
    reinvestmentPeriodEndYrsColumn,
    outOfNcColumn,
    outOfRiColumn,
} from '../../../../clo-managers/tabs/deals/columns';
import { PipelineColumn } from '../../../../amrPipeline/types/PipelineColumn';
import { SORTING_TYPE, constants, pipelineColumnLabels } from '../../../../../constants';
import { IColumnDefinition } from '../../../../bidding/common/table/types/ColumnDefinition';
import { OriginatingTransaction } from '../../../../../types/amr-pipeline/models/OriginatingTransaction';
import { ManagerLink } from '../../../../amrPipeline/common/ManagerLink';
import { SubscriptionFeature } from '../../../../../types/billing/SubscriptionFeature';
import { shareOptionColumnDefinition } from '../../../../amrPipeline/aggregated/deal-view/columns/optionsColumn';
import { createColumnListBuilder } from '../../../../../utils/ColumnListBuilder';

export const getBanksDealColumns = (isShareAvailable: boolean) => {
    const dealColumns = [
        isNewColumn,
        createLastUpdatedColumn([SubscriptionFeature.DealerProfileDeals, SubscriptionFeature.IssuanceMonitorHistoricalData]),
        dealNameColumn,
        dealTickerColumn,
        {
            columnKey: PipelineColumn.manager,
            renderColumnHeaderContent: () => pipelineColumnLabels[PipelineColumn.manager],
            renderColumnContent: (transaction, context) => {
                const { onManagerClick } = context;
                const { collateralManager } = transaction;

                if (!collateralManager) {
                    return constants.emptyPlaceholder;
                }

                return (
                    <ManagerLink
                        referenceName={collateralManager.referenceName}
                        legalName={collateralManager.legalName}
                        onClick={onManagerClick}
                    />
                );
            },
            sortingField: 'collateralManager',
            sortingType: SORTING_TYPE.company,
            className: 'data-list-cell-xl',
        } as IColumnDefinition<OriginatingTransaction>,
        transactionStatusColumn,
        transactionTypeColumn,
        transactionCollateralTypeColumn,
        transactionCurrencyColumn,
        transactionSizeColumn,
        pricingDateColumn,
        closingDateColumn,
        nonCallPeriodEndColumn,
        nonCallPeriodEndYrsColumn,
        outOfNcColumn,
        reinvestmentPeriodEndColumn,
        reinvestmentPeriodEndYrsColumn,
        outOfRiColumn,
        collapseStickRightColumn,
        dealOptionsColumn,
    ];

    return createColumnListBuilder<OriginatingTransaction>()
        .add(...dealColumns)
        .addWhen(() => isShareAvailable, shareOptionColumnDefinition)
        .add(dealIntexColumn)
        .add(createGoToColumn([SubscriptionFeature.DealerProfileDeals, SubscriptionFeature.IssuanceMonitorHistoricalData]))
        .add(createRelatedTransactionsColumn([SubscriptionFeature.DealerProfileDeals, SubscriptionFeature.IssuanceMonitorMarketingHistory]))
        .result()
        .map(x => new ColumnBuilder(x));    
}    
